// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".axpp5DRS199bLVF4uJqW{height:32px;width:32px;overflow:hidden}.HED2kKWHuNXGfe8vjNkW{height:64px;width:64px;overflow:hidden}", "",{"version":3,"sources":["webpack://./src/components/Teams-styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,UAAA,CACA,eAAA,CAGD,sBACC,WAAA,CACA,UAAA,CACA,eAAA","sourcesContent":[".groupImage {\n\t\theight: 32px;\n\t\twidth: 32px;\n\t\toverflow: hidden;\n\t}\n\n\t.teamImage {\n\t\theight: 64px;\n\t\twidth: 64px;\n\t\toverflow: hidden;\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"groupImage": "axpp5DRS199bLVF4uJqW",
	"teamImage": "HED2kKWHuNXGfe8vjNkW"
};
export default ___CSS_LOADER_EXPORT___;
